export const templateFields = [
    { label: "Form", size: "M", fieldVal: "form" , fieldType: "Dropdown" , options:['BDC' , 'Agency']},
    { label: "Type", size: "M", fieldVal: "type" , fieldType: "Dropdown" , options:['Rentals' ,'Sales']},

    { label: "Form Name", size: "M", fieldVal: "formName" , fieldType: "Text" },
    { label: "Local Path", size: "M", fieldVal: "localPath" , fieldType: "Text" },

    // { label: "Form Description", size: "M", fieldVal: "formDescription" ,fieldType: "Text"},
    // { label: "Required ?", size: "L", fieldVal: "isRequired" ,fieldType: "Radio" , options:["Yes" , "No"]},
    // { label: "Template", size: "L", fieldVal: "formTemplate" ,fieldType: "RichText"},
    // { label: "Header", size: "M", fieldVal: "header" ,fieldType: "Radio" , options:["Yes" , "No"]},
    // { label: "Footer", size: "M", fieldVal: "footer" ,fieldType: "Radio" , options:["Yes" , "No"]},
]